module.exports = __webpack_public_path__ + "static/media/hair-more.9bea711c.png";